<template>
  <div
    class=""
    :class="{
      'mb-15': $vuetify.breakpoint.smAndUp,
      'mb-6': !$vuetify.breakpoint.smAndUp
    }"
  >
    <div class="px-5">
      <router-link :to="{ name: $constants.ROUTE_NAME.ORDER_DETAIL, params: { poNumber: item.po_number } }" class="font-weight-bold secondary--text">
        {{ $t('label.orderId') }} {{ item.po_number }}
      </router-link>
      <div v-for="orderItem in item.items" :key="orderItem.order_id" class="d-flex flex-row my-4 w-100">
        <img :src="orderItem.product_image" class="mr-5 order-image rounded-lg elevation-3" />
        <div
          class="d-flex w-100"
          :class="{
            'flex-row justify-space-between align-start': $vuetify.breakpoint.smAndUp,
            'flex-column align-start justify-start ': !$vuetify.breakpoint.smAndUp
          }"
        >
          <div class="w-100">
            <p class="text-subtitle-2 font-weight-bold grey--text text-wrap">
              {{ orderItem.product_subcategory_name }}
            </p>
            <p class="text-subtitle-2 secondary--text text-wrap" style="word-break: break-all; line-height: 120%">
              {{ orderItem.product_name }}
            </p>
            <p class="text-subtitle-2 secondary--text text-wrap" style="word-break: break-all">
              {{ orderItem.size }}
            </p>
            <p class="text-subtitle-2 secondary--text" v-if="orderItem.product_volume_variation_id">
              {{ orderItem.product_volume_variation_name }}
            </p>
            <p class="text-body secondary--text font-weight-medium">{{ orderItem.currency }} {{ formatPrice(orderItem.unit_price) }}</p>
            <p class="text-body secondary--text font-weight-medium">{{ $t('label.qty') }}: {{ orderItem.quantity }}</p>
          </div>
          <p
            v-if="item.status === 5 || item.status === 6"
            class="primary--text text--darken-1 font-weight-medium"
            :class="{
              'align-self-center': $vuetify.breakpoint.smAndUp,
              'align-self-end': !$vuetify.breakpoint.smAndUp
            }"
          >
            {{ item.status === 5 ? $t('label.cancelled') : item.status_name }}
          </p>
          <p
            v-if="item.status === 9"
            class="orange--text text--darken-1 font-weight-medium"
            :class="{ 'primary--text': orderItem.request_return_status !== 'Pending', 'align-self-center': $vuetify.breakpoint.smAndUp, 'align-self-end': !$vuetify.breakpoint.smAndUp }"
          >
            {{ orderItem.request_return_status }}
          </p>
          <v-btn
            v-if="orderItem.can_returnrefund"
            color="primary"
            class="d-block rounded-pill green-gradient-right text-capitalize d-flex"
            :class="{
              'ml-10 px-10': $vuetify.breakpoint.smAndUp,
              'px-3 align-self-end': !$vuetify.breakpoint.smAndUp
            }"
            @click="
              $router.push({
                name: $constants.ROUTE_NAME.ORDER_REFUND,
                params: { order_id: item.order_id, product_id: orderItem.product_id },
                hash: orderItem.product_volume_variation_id && `#${orderItem.product_volume_variation_id}`
              })
            "
          >
            {{ $t('label.returnRefund') }}
          </v-btn>
        </div>
      </div>
    </div>
    <div
      v-if="item.status === 12"
      class="orange py-2 white--text rounded-sm text-body-2 d-flex flex-row"
      :class="{
        'px-10': $vuetify.breakpoint.smAndUp,
        'px-2': !$vuetify.breakpoint.smAndUp
      }"
    >
      <v-icon outlined color="green" class="transparent mr-2">mdi-alert-circle-outline</v-icon>
      <p>{{ $t('message.deliveryAttemptFailed') }}</p>
    </div>
    <div v-if="item.items.length > 0 && item.items.filter((f) => f.can_returnrefund).length > 0" class="primary darken-1 py-2 px-10 white--text rounded-sm text-body-2">
      {{ $t('message.returnRefund') }}
    </div>
    <div
      class="total-bg rounded-sm py-3 my-2 d-flex flex-row justify-space-between align-center"
      :class="{
        'px-5': $vuetify.breakpoint.smAndUp,
        'px-2': !$vuetify.breakpoint.smAndUp
      }"
    >
      <div>
        <span class="mr-2">{{ $t('label.total') }}:</span>
        {{ item.currency }} {{ formatPrice(item.final_amount) }}
      </div>
      <div class="d-flex flex-row">
        <v-btn v-if="item.can_cancel" color="primary" outlined class="ml-10 px-10 d-block rounded-pill text-capitalize" @click="$emit('cancel', item)">{{ $t('label.cancelOrder') }}</v-btn>
        <v-btn
          v-if="item.status === 0"
          color="primary"
          class="ml-10 px-10 d-block rounded-pill green-gradient-right text-capitalize"
          @click="$router.push({ name: $constants.ROUTE_NAME.ORDER_PAYMENT, params: { poNumber: item.po_number } })"
        >
          {{ $t('label.payNow') }}
        </v-btn>
        <v-btn
          v-if="item.can_reschedule"
          color="primary"
          class="ml-10 px-10 d-block rounded-pill green-gradient-right text-capitalize"
          @click="$router.push({ name: $constants.ROUTE_NAME.ORDER_DELIVERY, params: { id: item.order_id } })"
        >
          {{ $t('label.reschedule') }}
        </v-btn>
        <v-btn v-if="item.status === 9" color="primary" class="ml-10 px-10 d-block rounded-pill green-gradient-right text-capitalize d-flex" :href="`mailto:${customerServiceEmail}`" target="_blank">
          {{ $t('label.contactOly') }}
        </v-btn>
        <v-btn v-if="item.status === 5" color="primary" class="ml-10 px-10 d-block rounded-pill green-gradient-right text-capitalize d-flex" @click="$emit('addToCart', item)">
          {{ $t('label.addToCart') }}
        </v-btn>
        <v-btn v-if="item.can_review" color="primary" class="ml-10 px-10 d-block rounded-pill green-gradient-right text-capitalize d-flex" :to="{ name: $constants.ROUTE_NAME.PRODUCT_REVIEW }">
          {{ $t('label.writeReview') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { uiHelper } from '@/utils'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('page', ['customerServiceEmail'])
  },
  methods: {
    formatPrice(val) {
      return uiHelper.priceFormatter(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.order-image {
  width: 120px;
  height: 120px;
  object-fit: cover;

  @media only screen and (min-width: 640px) {
    width: 180px;
    height: 180px;
  }
  @media only screen and (min-width: 1800px) {
    width: 200px;
    height: 200px;
  }
}

.total-bg {
  background-color: var(--v-secondary-lighten5) !important;
  border-color: var(--v-background-base) !important;
}

.voucher-image {
  width: 200px;
  height: 200px;
  padding: 20px 30px;
  object-fit: contain;
}

.unavailable-item {
  filter: opacity(0.6);
}
</style>
